import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { JiraAppSelectorIcon } from './jira-app-selector';
import { messages } from './messages';

const styles = cssMap({
	moreButtonStyles: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.small'),
		display: 'flex',
		marginLeft: token('space.050'),
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
});

type Props = {
	appCount?: number;
	/**
	 * Optional custom icon content to render instead of the default static JiraAppSelectorIcon.
	 * When provided, this replaces the hardcoded icon strip.
	 */
	icon?: React.ReactNode;
};

export const AllAppsIcon = ({ appCount, icon }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const label =
		appCount !== undefined && appCount > 0
			? formatMessage(messages.moreWithCount, { appCount })
			: formatMessage(messages.more);

	return (
		<Flex role="presentation" alignItems="center">
			{icon ?? <JiraAppSelectorIcon />}

			<Box xcss={styles.moreButtonStyles}>
				<Text size="small" align="center" color="color.text.subtle">
					{label}
				</Text>
			</Box>
		</Flex>
	);
};
